var RoleCategories = /** @class */ (function () {
    function RoleCategories() {
    }
    RoleCategories.SuperAdmin = 'Super Admin';
    RoleCategories.Technician = 'Technician';
    RoleCategories.Others = 'Others';
    return RoleCategories;
}());
export { RoleCategories };
